export const locale = {
  lang: 'en',
  data: {
    MENU: {
      HOME: 'Home',
      SAMPLE: 'Sample',
      PAGES:{
        KYC: 'KYC',
        INVEST: 'Buy Fractions',
        CREATE: "Sell Properties",
        VERIFY: "Verify"
      }
    }
  }
}
